import refs from '../refsLite'
import { updateDoc } from 'firebase/firestore/lite'

export async function updateAclPublicData(path, publicData) {
  await updateDoc(refs.acl(path, false), { publicData })
}
